import {ChatPopup, ChatPopupProps} from './ChatPopup';

export default ChatPopup;
export type {ChatPopupProps};